<template>
  <div class="production_wrap">
    <div class="production_img" id="cpjz">
      <div class="production_img_inner">
        <div class="img_desc">良悦仓储管理系统WMS解决方案</div>
        <div class="img_tit">优化作业流程，构建数智透明仓储，赋能高效管理</div>
<!--        <div class="img_desc">从设计到交付，数字化全链贯通，一站式数字化制造服务，让效率与质量双擎驱动</div>-->
        <router-link class="img_btn" to="/Experience">立即咨询</router-link>
      </div>

    </div>
    <div class="tab-area hidden-xs-only">
      <div class="tab-area-bg"></div>
      <el-tabs v-model="activeName" @tab-click="handleClick" class="tabs">
        <el-tab-pane label="系统定位" name="first"></el-tab-pane>
        <el-tab-pane label="业务流程" name="second"></el-tab-pane>
        <el-tab-pane label="核心功能" name="third"></el-tab-pane>
        <el-tab-pane label="业务场景" name="seven"></el-tab-pane>
        <el-tab-pane label="设备支持" name="fourth"></el-tab-pane>
        <el-tab-pane label="关联模块" name="five"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="service-card" >
      <div class="production_inner">
        <div class="inner_center">
          <div class="production_title">系统定位</div>
          <div class="production_desc">仓储智能化的中枢神经</div>
        </div>
      </div>

      <div class="production_box" >
        <div class="production_item">
          <div class="title">
            <img  src="../../assets/img/solution/kcjzh.png"/>
            <div>库存精准化</div>
            <div class="content">实现库位级实时可视化管理，提升库存准确率</div>
          </div>
        </div>
        <div class="production_item">
          <div class="title">
            <img  src="../../assets/img/solution/zygxh.png"/>
            <div>作业高效化</div>
            <div class="content">通过智能策略（储位配、路径规划）降低人工成本</div>
          </div>
        </div>
        <div class="production_item">
          <div class="title">
            <img  src="../../assets/img/solution/zdxth.png"/>
            <div>自动协同化</div>
            <div class="content">对接AGV、堆垛机、分拣机等设备，构建无人仓作业体系</div>
          </div>
        </div>
        <div class="production_item">
          <div class="title">
            <img  src="../../assets/img/solution/xvyhq.png"/>
            <div>合规可追溯</div>
            <div class="content">满足GMP/FDA/ISO等质量规范，支持批次/序列号全生命周期追溯</div>
          </div>
        </div>
      </div>
</div>

    <div class="tedian">
      <div class="production_title_wrap flow-title">
        <div class="production_inner">
          <div class="inner_center">
            <div class="production_title"  id="cptd">良悦WMS解决方案业务流程</div>
          </div>
        </div>
      </div>
      <div class="title_card"><img src="../../assets/img/solution/WMS_title.svg"/></div>
      <div class="production_card">
        <img src="../../assets/img/solution/WMS.svg" class="gaizao"/>
      </div>
    </div>

      <div class="hexin-area" >
        <div class="production_inner">
          <div class="inner_center">
            <div class="production_title"  id="fwfc">核心功能</div>
            <div class="production_desc">仓储智能化的中枢神经</div>
          </div>
        </div>
        <div class="production_card wms-hx hidden-sm-and-up">
          <el-row :gutter="10">
            <el-col :span="12" class="mo-col">
              <div class="mo-div">
                <img src="../../assets/img/solution/wms-hx/hx-rkgl.svg" class="mo-item-img">
                <div class="mo-item-title">入库管理</div>
                <div class="mo-item-desc">预约排程、质检触发、策略上架（按批次/效期/温度分区）、容器化管理（托盘/周转箱绑定）</div>
              </div>
            </el-col>
            <el-col :span="12" class="mo-col">
              <div class="mo-div">
                <img src="../../assets/img/solution/wms-hx/hx-kcgl.svg" class="mo-item-img">
                <div class="mo-item-title">库存管理</div>
                <div class="mo-item-desc">批次/序列号追踪、效期预警、库龄分析、库存分布热力图、呆滞库存自动标记</div>
              </div>
            </el-col>
            <el-col :span="12" class="mo-col">
              <div class="mo-div">
                <img src="../../assets/img/solution/wms-hx/hx-zyclyq.svg" class="mo-item-img">
                <div class="mo-item-title">作业策略引擎</div>
                <div class="mo-item-desc">储位分配算法（基于周转率/商品特性）、波次生成规则（按订单类型/承运商）、拣货路径优化</div>
              </div>
            </el-col>
            <el-col :span="12" class="mo-col">
              <div class="mo-div">
                <img src="../../assets/img/solution/wms-hx/hx-zdhjc.svg" class="mo-item-img">
                <div class="mo-item-title">自动化集成</div>
                <div class="mo-item-desc">堆垛机控制指令、自动分拣线联动（DWS称重扫码）</div>
              </div>
            </el-col>
            <el-col :span="12" class="mo-col">
              <div class="mo-div">
                <img src="../../assets/img/solution/wms-hx/hx-kshjk.svg" class="mo-item-img">
                <div class="mo-item-title">可视化监控</div>
                <div class="mo-item-desc">3D仓库建模、设备运行状态看板、作业效率实时排名</div>
              </div>
            </el-col>
            <el-col :span="12" class="mo-col">
              <div class="mo-div">
                <img src="../../assets/img/solution/wms-hx/hx-ydhyy.svg" class="mo-item-img">
                <div class="mo-item-title">移动化应用</div>
                <div class="mo-item-desc">PDA扫码作业（收货/拣货/盘点）、叉车终端导航</div>
              </div>
            </el-col>
            <el-col :span="12" class="mo-col">
              <div class="mo-div">
                <img src="../../assets/img/solution/wms-hx/hx-zlgl.svg" class="mo-item-img">
                <div class="mo-item-title">质量管理</div>
                <div class="mo-item-desc">质检规则库（AQL抽样标准）、不合格品冻结流程、质量报告自动生成</div>
              </div>
            </el-col>
            <el-col :span="12" class="mo-col">
              <div class="mo-div">
                <img src="../../assets/img/solution/wms-hx/hx-jfycb.svg" class="mo-item-img">
                <div class="mo-item-title">计费与成本</div>
                <div class="mo-item-desc">仓储费用核算（存储费/操作费）、外包物流对账、单件物流成本分析</div>
              </div>
            </el-col>
            <el-col :span="12" class="mo-col">
              <div class="mo-div">
                <img src="../../assets/img/solution/wms-hx/hx-yjybb.svg" class="mo-item-img">
                <div class="mo-item-title">预警与报表</div>
                <div class="mo-item-desc">库存阈值预警、效期临期提醒、作业超时报警、KPI报表（拣货效率/库存周转率）</div>
              </div>
            </el-col>
            <el-col :span="12" class="mo-col">
              <div class="mo-div">
                <img src="../../assets/img/solution/wms-hx/hx-kfapi.svg" class="mo-item-img">
                <div class="mo-item-title">开放API平台</div>
                <div class="mo-item-desc">提供标准接口与ERP/MES/SCM对接，支持第三方系统数据对接</div>
              </div>
            </el-col>

          </el-row>
        </div>
        <div class="production_card wms-hx hidden-xs-only">
          <div class="hx-left">
            <div class="left-item" @mouseover="rkgl=true" @mouseleave="rkgl=false">
              <el-row>
                <el-col :span="18">
                  <div class="item-title">入库管理</div>
                  <div class="item-desc">预约排程、质检触发、策略上架（按批次/效期/温度分区）、容器化管理（托盘/周转箱绑定）</div>
                </el-col>
                <el-col :span="6">
                  <img src="../../assets/img/solution/wms-hx/hx-rkgl-w.svg" class="item-img" v-if="rkgl">
                  <img src="../../assets/img/solution/wms-hx/hx-rkgl.svg" class="item-img" v-else>
                </el-col>
              </el-row>
            </div>
            <div class="left-item" @mouseover="kcgl=true" @mouseleave="kcgl=false">
              <el-row>
                <el-col :span="18">
                  <div class="item-title">库存管理</div>
                  <div class="item-desc">批次/序列号追踪、效期预警、库龄分析、库存分布热力图、呆滞库存自动标记</div>
                </el-col>
                <el-col :span="6">
                  <img src="../../assets/img/solution/wms-hx/hx-kcgl-w.svg" class="item-img" v-if="kcgl">
                  <img src="../../assets/img/solution/wms-hx/hx-kcgl.svg" class="item-img" v-else>
                </el-col>
              </el-row>
            </div>
            <div class="left-item" @mouseover="zyclyq=true" @mouseleave="zyclyq=false">
              <el-row>
                <el-col :span="18">
                  <div class="item-title">作业策略引擎</div>
                  <div class="item-desc">储位分配算法（基于周转率/商品特性）、波次生成规则（按订单类型/承运商）、拣货路径优化</div>
                </el-col>
                <el-col :span="6">
                  <img src="../../assets/img/solution/wms-hx/hx-zyclyq-w.svg" class="item-img" v-if="zyclyq">
                  <img src="../../assets/img/solution/wms-hx/hx-zyclyq.svg" class="item-img" v-else>
                </el-col>
              </el-row>
            </div>
            <div class="left-item" @mouseover="zdhjc=true" @mouseleave="zdhjc=false">
              <el-row>
                <el-col :span="18">
                  <div class="item-title">自动化集成</div>
                  <div class="item-desc">堆垛机控制指令、自动分拣线联动（DWS称重扫码）</div>
                </el-col>
                <el-col :span="6">
                  <img src="../../assets/img/solution/wms-hx/hx-zdhjc-w.svg" class="item-img" v-if="zdhjc">
                  <img src="../../assets/img/solution/wms-hx/hx-zdhjc.svg" class="item-img" v-else>
                </el-col>
              </el-row>
            </div>
            <div class="left-item last-item-bottom"  @mouseover="kshjk=true" @mouseleave="kshjk=false">
              <el-row>
                <el-col :span="18">
                  <div class="item-title">可视化监控</div>
                  <div class="item-desc">3D仓库建模、设备运行状态看板、作业效率实时排名</div>
                </el-col>
                <el-col :span="6">
                  <img src="../../assets/img/solution/wms-hx/hx-kshjk-w.svg" class="item-img" v-if="kshjk">
                  <img src="../../assets/img/solution/wms-hx/hx-kshjk.svg" class="item-img" v-else>
                </el-col>
              </el-row>
            </div>
          </div>
          <div  class="hx-center"><img src="../../assets/img/solution/wms-hx-line.svg" /></div>
          <div class="hx-right">
            <div class="right-item" @mouseover="ydhyy=true" @mouseleave="ydhyy=false">
              <el-row>
                <el-col :span="6">
                  <img src="../../assets/img/solution/wms-hx/hx-ydhyy-w.svg" class="item-img" v-if="ydhyy">
                  <img src="../../assets/img/solution/wms-hx/hx-ydhyy.svg" class="item-img" v-else>
                </el-col>
                <el-col :span="18">
                  <div class="item-title">移动化应用</div>
                  <div class="item-desc">PDA扫码作业（收货/拣货/盘点）、叉车终端导航</div>
                </el-col>
              </el-row>
            </div>
            <div class="right-item" @mouseover="zlgl=true" @mouseleave="zlgl=false">
              <el-row>

                <el-col :span="6">
                  <img src="../../assets/img/solution/wms-hx/hx-zlgl-w.svg" class="item-img" v-if="zlgl">
                  <img src="../../assets/img/solution/wms-hx/hx-zlgl.svg" class="item-img" v-else>
                </el-col>
                <el-col :span="18">
                  <div class="item-title">质量管理</div>
                  <div class="item-desc">质检规则库（AQL抽样标准）、不合格品冻结流程、质量报告自动生成</div>
                </el-col>
              </el-row>
            </div>
            <div class="right-item" @mouseover="jfycb=true" @mouseleave="jfycb=false">
              <el-row>

                <el-col :span="6">
                  <img src="../../assets/img/solution/wms-hx/hx-jfycb-w.svg" class="item-img" v-if="jfycb">
                  <img src="../../assets/img/solution/wms-hx/hx-jfycb.svg" class="item-img" v-else>
                </el-col>
                <el-col :span="18">
                  <div class="item-title">计费与成本</div>
                  <div class="item-desc">仓储费用核算（存储费/操作费）、外包物流对账、单件物流成本分析</div>
                </el-col>
              </el-row>
            </div>
            <div class="right-item" @mouseover="yjybb=true" @mouseleave="yjybb=false">
              <el-row>

                <el-col :span="6">
                  <img src="../../assets/img/solution/wms-hx/hx-yjybb-w.svg" class="item-img" v-if="yjybb">
                  <img src="../../assets/img/solution/wms-hx/hx-yjybb.svg" class="item-img" v-else>
                </el-col>
                <el-col :span="18">
                <div class="item-title">预警与报表</div>
                <div class="item-desc">库存阈值预警、效期临期提醒、作业超时报警、KPI报表（拣货效率/库存周转率）</div>
              </el-col>

              </el-row>
            </div>
            <div class="right-item last-item-bottom" @mouseover="kfapipt=true" @mouseleave="kfapipt=false">
              <el-row>

                <el-col :span="6">
                  <img src="../../assets/img/solution/wms-hx/hx-kfapi-w.svg" class="item-img" v-if="kfapipt">
                  <img src="../../assets/img/solution/wms-hx/hx-kfapi.svg" class="item-img" v-else>
                </el-col>
                <el-col :span="18">
                  <div class="item-title">开放API平台</div>
                  <div class="item-desc">提供标准接口与ERP/MES/SCM对接，支持第三方系统数据对接</div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
<!--          <el-row class="card_wrap " type="flex" >-->
<!--            <el-col-->
<!--                class="brain_item"-->
<!--                :lg="7"-->
<!--                :sm="11"-->
<!--                :xs="11"-->
<!--                v-for="(item, index) in cardList"-->
<!--                :key="index"-->
<!--            >-->
<!--              <div class="item_bg"></div>-->
<!--              <el-row style="z-index: 2">-->
<!--                <el-col :span="24">-->
<!--                  <div class="item_bg_div"><img :src="item.src" alt="" class="img_item"/></div>-->
<!--                </el-col>-->
<!--                <el-col :span="24" class="con">-->
<!--                  <div class="item_title">{{ item.title }}</div>-->
<!--                  <div class="item_desc">{{ item.desc1 }}</div>-->
<!--                </el-col>-->
<!--              </el-row>-->

<!--              &lt;!&ndash;        <div class="item_title">{{ item.title }}</div>&ndash;&gt;-->
<!--              &lt;!&ndash;        <div class="item_desc">{{ item.desc }}</div>&ndash;&gt;-->
<!--              &lt;!&ndash;        <div class="item_navigate" @click="handleNavigate">了解详情 >></div>&ndash;&gt;-->
<!--              &lt;!&ndash;        <div class="item_bg"></div>&ndash;&gt;-->
<!--            </el-col>-->
<!--          </el-row>-->

      </div>
    <span id="ywcj"></span>
    <div class="production_title_wrap">
      <div class="production_inner">
        <div class="inner_center">
          <div class="production_title">WMS系统业务场景关系</div>
          <div class="production_desc hidden-xs-only">良悦WMS是面向于制造业的仓储管理系统，可有效应对复杂的物料管理及仓库业务，实现智能仓储管理模式</div>
        </div>
      </div>
      <div class="production_card">
        <img src="../../assets/img/solution/WMS_scenario.png" class="gaizao"/>
      </div>
    </div>
    <span id="gzfx"></span>
    <div class="tedian1"  >
      <div class="production_title_wrap">
        <div class="production_inner">
          <div class="inner_center">
            <div class="production_title">设备支持</div>
          </div>
        </div>
      </div>
      <div class="production_card">
        <el-row class="row-area" id="glmk">
          <el-col :span="4" :xs="24" class="col-area">
            <div class="first-btn">多终端适配</div>
          </el-col>
          <el-col :span="1" class="hidden-xs-only">
            <el-divider direction="vertical" />
          </el-col>
          <el-col :span="4" :xs="5" class="col-area">
            <img src="../../assets/img/solution/pc.svg" />PC端
          </el-col>
          <el-col :span="1">
            <el-divider direction="vertical" />
          </el-col>
          <el-col :span="4" :xs="5" class="col-area">
            <img src="../../assets/img/solution/app.svg" />手机APP
          </el-col>
          <el-col :span="1">
            <el-divider direction="vertical" />
          </el-col>
          <el-col :span="4" :xs="5" class="col-area">
            <img src="../../assets/img/solution/xcx.svg" />微信小程序
          </el-col>
          <el-col :span="1">
            <el-divider direction="vertical" />
          </el-col>
          <el-col :span="4" :xs="6" class="col-area">
            <img src="../../assets/img/solution/dpd.svg" />大屏端
          </el-col>
        </el-row>
        <el-row class="row-area">
          <el-col :span="4" :xs="24" class="col-area">
            <div class="first-btn">数据中心适配</div>
          </el-col>
          <el-col :span="1" class="hidden-xs-only">
            <el-divider direction="vertical" />
          </el-col>
          <el-col :span="4" :xs="5" class="col-area">
            <img src="../../assets/img/solution/crh.svg" />超融合
          </el-col>
          <el-col :span="1">
            <el-divider direction="vertical" />
          </el-col>
          <el-col :span="4" :xs="5" class="col-area">
            <img src="../../assets/img/solution/xnh.svg" />虚拟化
          </el-col>
          <el-col :span="1">
            <el-divider direction="vertical" />
          </el-col>
          <el-col :span="4" :xs="5" class="col-area">
            <img src="../../assets/img/solution/syy.svg" />私有云
          </el-col>
          <el-col :span="1">
            <el-divider direction="vertical" />
          </el-col>
          <el-col :span="4" :xs="6" class="col-area">
            <img src="../../assets/img/solution/ctit.svg" />传统IT架构
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="production_title_wrap">
      <div class="production_inner">
        <div class="inner_center">
          <div class="production_title">关联模块</div>
        </div>
      </div>
      <div class="production_card">
      <el-row :gutter="20" class="guanlian-row-area">
        <el-col :span="8" :xs="24" class="guanlian-col">
          <el-card :body-style="{ padding: '0px' }">
            <img src="../../assets/img/solution/gl1.jpg" class="image">
            <span class="guanli-title">纵向关联</span>
            <div class="guanli-area">
              <span>企业资源管理系统ERP</span>
              <div class="time">接收入库计划与销售订单，反馈实际库存与作业成本数据</div>
              <span>制造执行系统MES</span>
              <div class="time">同步生产领料需求，触发JIT配送任务并反馈物料消耗</div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="8" :xs="24" class="guanlian-col">
          <el-card :body-style="{ padding: '0px' }">
            <img src="../../assets/img/solution/gl2.jpg" class="image">
            <span class="guanli-title">横向扩展</span>
            <div class="guanli-area">
              <span>供应链管理系统SCM</span>
              <div class="time">指导车辆调度，反馈在途库存状态</div>
              <span>供应商关系管理系统SRM</span>
              <div class="time">供应商绩效数据（到货准时率/质检合格率）反哺采购决策</div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="8" :xs="24" class="guanlian-col">
          <el-card :body-style="{ padding: '0px' }">
            <img src="../../assets/img/solution/gl3.jpg" class="image">
            <span class="guanli-title">底层数据互通</span>
            <div class="guanli-area">
              <span>ERP、APS、数据中台</span>
              <div class="time">&emsp;</div>
            </div>
          </el-card>
        </el-col>
<!--        <el-col :span="8">-->
<!--          <el-card :body-style="{ padding: '0px' }">-->
<!--            <img src="../../assets/img/solution/gl3.jpg" class="image">-->
<!--            <div class="guanli-area">-->
<!--              <span>AI与大数据</span>-->
<!--              <div class="time">分析历史数据预测故障，生成智能优化建议</div>-->
<!--            </div>-->
<!--          </el-card>-->
<!--        </el-col>-->
      </el-row>
      </div>
    </div>
    <div class="tedian1 padding80" >
      <Zixun />
    </div>
    <CallMe />
    <MobileCallme />
  </div>
</template>

<script>
// import ProCard from './ProCard.vue'
import CallMe from '@/components/callme/index'
import MobileCallme from '@/components/callme/MobileCallme.vue'
import Zixun from "@/components/zixun/index.vue";
export default {
  data() {
    return {
      activeName:"first",
      currentSub:"",
      rkgl:false,
      kcgl:false,
      zyclyq:false,
      zdhjc:false,
      kshjk:false,
      ydhyy:false,
      zlgl:false,
      jfycb:false,
      yjybb:false,
      kfapipt:false,
    }
  },
  components: {
    Zixun,
    CallMe,
    MobileCallme,
  },
  mounted() {
    this.activeName="first"
    let elements = document.querySelectorAll('.tab-area');
    window.onscroll = () => {
      if(document.documentElement.scrollTop > 420){
        elements.forEach(function(element) {
          element.classList.add('tab-area-fixed');
        });
        if(document.documentElement.scrollTop > 500){
          this.activeName="second"
        }
        if(document.documentElement.scrollTop > 1700){
          this.activeName="third"
        }
        if(document.documentElement.scrollTop > 2500){
          this.activeName="seven"
        }
        if(document.documentElement.scrollTop > 3100){
          this.activeName="fourth"
        }
        if(document.documentElement.scrollTop > 3900){
          this.activeName="five"
        }
      }else {
        this.activeName="first"
        elements.forEach(function (element) {
          element.classList.remove('tab-area-fixed');
        });
      }
    }
  },
  methods:{
    overSub(flag){
      this.currentSub = flag
    },
    outSub(){
      this.currentSub = ''
    },
    handleClick(){
      if(this.activeName==="first"){
        const element = document.getElementById('cpjz');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' ,block: 'start'});
        }
      }
      if(this.activeName==="second"){
        const element = document.getElementById('cptd');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' ,block: 'center'});
        }
      }
      if(this.activeName==="third"){
        const element = document.getElementById('fwfc');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' ,block: 'center'});
        }
      }
      if(this.activeName==="seven"){
        const element = document.getElementById('ywcj');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' ,block: 'center'});
        }
      }
      if(this.activeName==="fourth"){
        const element = document.getElementById('gzfx');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' ,block: 'center'});
        }
      }
      if(this.activeName==="five"){
        const element = document.getElementById('glmk');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' ,block: 'start'});
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.mo-col{
  margin-bottom: 10PX;

}
.mo-div{
  padding: 10PX 10PX 10PX 10PX;
  height: 190PX;
  border-radius: 5PX;
  background: linear-gradient(180deg, rgba(243, 245, 248, 1) 0%, rgba(255, 255, 255, 1) 100%);
  box-shadow: 10px 10px 24px 2px rgba(12, 28, 56, 0.06);
  border: 1PX solid rgba(255, 255, 255, 1);

}
.mo-item-img{
  width: 40%;
}
.mo-item-title{
  color: rgba(37, 53, 84, 1);
  font-size: 0.9rem;
  font-weight: bold;
  line-height: 2rem;
}
.mo-item-desc{
  color: rgba(128, 128, 128, 1);
  font-size: 0.7rem;
  line-height: 1.2rem;
}
.flow-title{
  padding-bottom: 0 !important;
}
.tedian1 {
  background-color: rgba(245, 247, 250, 1);
  padding: 5px 0 5px 0;
}
.tedian{
  background-color:#EDF5FF;
  padding: 5px 0 5px 0 ;
  .title_card{
    width: 77%;
    margin: 40px auto 0 auto;
    @media screen and (max-width: 768px) {
      width: 100%;
    }
    img{
      width: 100%;
      margin-bottom: 0;
    }
  }
  .production_card{
    margin-top: 20px !important;
  }

}
.hexin-area{
  background: url('../../assets/img/solution/wms-hx-bg.jpg') 0 0 no-repeat;
  background-size: 100% 100%;
  //height: 600px;
  padding-top: 30px;
  @media screen and (max-width: 768px) {
    background: rgba(245, 247, 250, 1);
    padding-top: 20PX;
  }

}
.production_wrap {
  width: 100%;
  margin-top: 70px;
  .production_img {
    background: url('../../assets/img/solution/wms-bg.jpg') 0 0 no-repeat;
    background-size: 100% 100%;
    @media screen and (max-width: 768px) {
      background-size: cover ;
      background-position: 50% 100%;
    }
  }
  .wms-hx{
    text-align: center;
    padding-top: 50px;
    padding-bottom: 10px;
    display: flex;

  }
  .hx-left{
    position: relative;
     float: left;
     width: 430px;
     margin-top: -50px;
    .left-item{
      background: linear-gradient(180deg, rgba(243, 245, 248, 1) 0%, rgba(255, 255, 255, 1) 100%);
      padding: 12px 10px 5px 10px ;
      border-radius: 100px;
      border: 2px solid #ffffff;
      box-shadow: 10px 10px 24px 2px rgba(12, 28, 56, 0.06);
      text-align: right;
      margin-bottom: 43px;
      &:hover{
        background: #00A4FF;
        border: 2px solid #00A4FF;
        .item-title {
          color:#fff;
        }
        .item-desc {
          color: #fff;
        }
      }
      .item-title {
        font-size: 18px;
        color:#253554;
        font-weight: bold;
        margin-bottom: 5px;

      }
      .item-desc {
        font-size: 12px;
        color: #808080;
      }
      .item-img {
        width: 80%;
      }
    }
  }
  .hx-center{
    position: relative;
    text-align: center;
    img{
      height: 600px;
    }
  }
  .hx-right{
    position: relative;
    float: right;
    width: 430px;
    margin-top: -50px;
    .right-item{
      background: linear-gradient(180deg, rgba(243, 245, 248, 1) 0%, rgba(255, 255, 255, 1) 100%);
      padding: 12px 10px 5px 10px ;
      border-radius: 100px;
      border: 2px solid #ffffff;
      box-shadow: 10px 10px 24px 2px rgba(12, 28, 56, 0.06);
      text-align: left;
      margin-bottom: 43px;
      &:hover{
        background: #00A4FF;
        border: 2px solid #00A4FF;
        .item-title {
          color:#fff;
        }
        .item-desc {
          color: #fff;
        }
      }
      .item-title {
        font-size: 18px;
        color:#253554;
        font-weight: bold;
        margin-bottom: 5px;

      }
      .item-desc {
        font-size: 12px;
        color: #808080;
      }
      .item-img {
        width: 80%;
      }
    }
  }
  .last-item-bottom{
    margin-bottom: -50px;
  }
  .production_title_wrap {
    width: 100%;
    margin-top: 50px;
    //padding-bottom: 50px;
    @media screen and (max-width: 768px) {
      margin-top: 30px;
    }
  }

  .bottom{
    width: 60%;
    margin: auto;
    text-align: center;
    margin-top: -80px;
    color: rgba(37, 53, 84, 0.5);
    font-size: 14px;
  }
  .production_box {
    margin: auto;
    width: 70%;
    display: flex;
    justify-content: center;
    margin-top: 40px;
    margin-bottom: 10px;
    @media screen and (max-width: 768px) {
      width: 95%;
      justify-content: space-around;
      flex-wrap: wrap;
    }
    .bg{
      width: 100%;
      border-radius: 4px;
    }
    .production_item {
      width: calc(100% / 4 - 12px); /* 减去间距 */
      margin: 8px 6px; /* 可根据需要调整 */
      padding-right: 40px;
      display: flex;
      @media screen and (max-width: 768px) {
        width: 100%;
        margin-left: 0;
        margin-top: 10PX;
        box-shadow: 2px 2px 5px 2px rgba(12, 28, 56, 0.05);
        border-radius: 4px;
        background: rgba(255, 255, 255, 1);
        padding: 20px 10px;
        border: 1px solid rgba(224, 236, 255, 1);

      }
      .title{
        width: 100%;
        font-size: 24px;
        color: rgba(37, 53, 84, 1);
        @media screen and (max-width: 768px) {
          font-size: 0.9rem;
          line-height: 1.5rem;
          font-weight: bold;
        }

        img{
          margin-bottom: 10px;
          width: 60px;
          @media screen and (max-width: 768px) {
            width:40PX;
            float: left;
            margin-right: 15PX;
          }

        }
        .content{
          margin-top: 10px;
          font-size: 14px;
          line-height: 24px;
          color: rgba(37, 53, 84, 0.6);
          @media screen and (max-width: 768px) {
            font-size: 0.7rem;
            line-height: 1.2rem;
            margin-left: 55PX;
            font-weight: normal;
          }
        }
      }
    }
  }
  p {
    text-align: center;
    color: #3b3b3b;
    font-weight: bold;
    font-size: 20px;
    line-height: 100px;
    @media screen and (max-width: 768px) {
      font-size: 0.9rem;
      padding: 15px 0;
    }
  }
  .service-card {
    width: 100%;
    margin: 50px auto;
    background-color: #fff;
  }
  .production_card {

    width: 70%;
    margin: 50px auto;
    @media screen and (max-width: 768px) {
      width: 95%;
      margin: 20PX auto;
    }

    .title-div{
      img{
        float: left;
        height: 30px;
        width: 1px;
        margin-top: 5px;
      }
      .title{
        float: left;
        font-size: 32px;
        line-height: 40px;
        font-weight: bold;
        color: #05102F;
        padding-right: 15px;
      }
      .desc{
        float: left;
        font-size: 22px;
        line-height: 40px;
        color: #808080;
        padding-left: 15px;
      }
    }
    .item-content{
      width: 100%;
      display: flex;
      justify-content: center;
      padding: 50px 0;
      .sub-item-yzs{
        border-radius: 4px;
        background: #FFFFFF;
        border: 1px solid #E0ECFF;
        padding: 10px;
        box-shadow: 6px 6px 16px 2px rgba(12, 28, 56, 0.1);
        width: calc(100% / 5 - 10px); /* 减去间距 */
        margin-right: 20px;
        .down-card{
          width: 100%;
          padding: 0 8px 0px 8px;
          color: #808080;
          line-height: 26px;
          font-size: 13px;
        }
        .up-card{
          display: flex;
          line-height: 60px;
          font-size: 22px;
          color: #16181A;
          font-weight: bold;
          img{
            width: 28%;
            margin-right: 5px;
          }
        }
        &:hover{
          box-shadow: 6px 6px 16px 2px rgba(12, 28, 56, 0.2);
          .up-card{
            color: #0052D9;
          }
        }
      }

    }
  }
  .advantage_out_wrap {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .carousel_pro {
    width: 60%;
    margin: 60px auto;
    .carousel_pro_item {
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
}
.basic-area{
  margin: auto;width: 70%;
  padding: 0 14px 30px 14px;

  .title{
    border-radius: 8px;color: #fff;
    background: #3393FD;
    line-height: 40px;
    text-align: center;
  }
  .content{
    border-radius: 8px;
    background: linear-gradient(180deg, #F6F8FF 0%, #D9E6FA 100%);
    border: 2px dashed #a3c4fe;
    width: 100%;
    margin-top: 10px;
    padding: 15px 8px;
    display: flex;
    .content-item{
      padding: 20px;
      text-align: center;
      margin: 0 1%;
      //float: left;
      width: 9%;
      border: 2px dashed #a3c4fe;
      background-color: #FBFDFF;
      border-radius: 8px;
      align-content: center;
      color: #05102F;
    }

  }
}
.production_core_scene{
  background-color: #F5F7FA;
  width: 70%;
  margin: 30px auto;
  padding: 30px 50px 20px 50px;
  height: 350px;
  border-radius: 4px;
  background: linear-gradient(180deg, rgba(2, 99, 255, 1) 41.2%, rgba(131, 181, 254, 1) 100%);
  .production_core_scene_title{
    align-content: center;
    color: #fff;
    letter-spacing: 2px;
    padding-bottom: 20px;
    .sub1{
      font-size: 32px;
      margin-right: 10px;
      font-weight: bold;
      line-height: 40px;
      float: left;
    }
    img{
      float: left;
      height: 30px;
      margin-top: 5px;
      width: 1px;
    }
    .sub2{
      margin-left: 10px;
      font-size: 20px;
      line-height: 40px;
      float: left;
    }
  }
  .item-bg{
    float: left;
    width: 24%;
    img{
      width: 90%;
    }
  }
  .item{
    float: left;
    width: 16%;
    padding: 0 20px;
    margin-left: 3%;
    text-align: center;
    border-radius: 4px;
    background: linear-gradient(0deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 1) 39.8%, rgba(255, 255, 255, 0.8) 64.35%, rgba(255, 255, 255, 0.6) 100%);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 230px;
    font-size: 12px;
    color: #8491AB;
    .bg{
      width: 46%;
    }
    .hx{
      margin: 10px 0;
      width: 100%;
    }
    .btn-area{
      width: 100%;
    }
    .left-div{
      flex: 1;
      width: 48%;
      background: #EBEFF5;
      line-height: 30px;
      border-radius: 4px;
      float: left;
      font-size: 13px;
      margin-right: 2%;
    }
    .right-div{
      width: 48%;
      flex: 1;
      background: #EBEFF5;
      line-height: 30px;
      border-radius: 4px;
      float: left;
      font-size: 13px;
    }
    span{
      font-size: 20px;
      line-height: 40px;
      font-weight: bold;
      color: #253554;
    }
  }

}
.tab-area{
  margin: auto;
  width: 100%;
  .tabs{
    margin: 0 15%;
    margin-top: -50px;
  }
  .tab-area-bg{
    background: #FFFFFF;
    height: 60px;
    box-shadow: 0 4px 12px rgba(12, 28, 56, 0.2);
  }
}
.tab-area-fixed{
  position: fixed;
  top: 70px;
  z-index: 999;
}
::v-deep(.el-tabs__nav-wrap::after){
  background-color: #fff !important;
}
::v-deep(.el-tabs__item ){
  margin-bottom: 10px;
}
::v-deep(.el-tabs__item.is-active ){
  color: #0052D9  !important;
}
::v-deep(.el-tabs__active-bar){
  background-color: #0052D9  !important;
  height: 3px;
}
.shenru-btn {
  width: 180px;
  height: 40px;
  background: #0052D9;
  color: #fff;
  bottom: 15%;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.5s;
  margin: 30px auto 10px auto;
  &:hover {
    color: #fff;
    font-weight: bold;
    background: #24b1ff;
  }
  @media screen and (max-width: 768px) {
    width: 80px;
    height: 30px;
    font-size: 14px;
  }
}
.gaizao{
  width: 100%;
  margin-bottom: 20px;
}
.padding80{
  padding-top: 80px
}
.card_wrap {
  width: 70%;
  flex-wrap: wrap;
  margin: 0px auto;
  padding-bottom: 20px;
  justify-content: space-between;
  @media screen and (max-width: 768px) {
    width: 95%;
  }
  .brain_item {
    transition: background-color 1s;
    padding: 20px 5px;
    //background: #fff;
    border-radius: 4px;
    //border: 2px solid #fff;
    //background: linear-gradient(180deg, #F3F5F8 0%, #FFFFFF 100%);
    //box-shadow: 0 0.5rem 1.5rem 0.5rem rgb(12 28 56 / 10%);
    margin-top: 40px;
    position: relative;
    @media screen and (max-width: 768px) {
      font-size: 0.8rem;
      line-height: 40PX;
      border-radius: 10PX;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      margin-top: 20PX;
      &:nth-child(-n+2){
        margin-top: 0;
      }
    }
    .img_item {
      margin-top: 18px;
      width: 60% ;
    }
    &:hover{
      //box-shadow: 0 0.5rem 1.5rem 0.5rem rgb(12 28 56 / 18%);
    }
    .item_bg {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      //background: linear-gradient(180deg, #F3F5F8 0%, #FFFFFF 100%);
      //box-shadow: 0 0.5rem 1.5rem 0.5rem rgb(12 28 56 / 12%);
      opacity: 0;
      transition: all 0.5s;
      border-radius: 4px;
      z-index: 1;
      //border: 1px solid #fff;

    }

    .item_bg_div{
      width:100px;
      height:100px;
      background:linear-gradient(180deg, rgba(237, 241, 252, 1) 0%, rgba(255, 255, 255, 1) 100%);
      box-shadow: 0 0.5rem 1.5rem 0.5rem rgba(12, 28, 56, 0.08);
      border: 2px solid #fff;
      border-radius: 50%;
      text-align: center;
      margin: auto;
      margin-bottom: 20px;
      &:hover{
        box-shadow: 0 0.5rem 2rem 0.5rem rgba(12, 28, 56, 0.128);
        border: 1px solid #fff;
      }
    }
    &:hover .item_bg{
      opacity: 1;
    }
    &:hover .item_title {
      color: #0052D9;
    }
    //&:hover .item_desc {
    //  color: #0052D9;
    //}
    .item_title {
      transition: all 0.5s;
      font-size: 18px;
      font-weight: bold;
      color: #203040;
      text-align: center;
      padding: 10px 0 10px 0;
      z-index: 2;
      position: inherit;
      @media screen and (max-width: 768px) {
        font-size: 1rem;
        text-align: center;
      }
    }
    .item_desc {
      width: 90%;
      transition: all 0.5s;
      color: #666;
      text-align: left;
      line-height: 24px;
      z-index: 2;
      position: inherit;
      font-size: 13px;
      min-height: 30px;
      margin: auto;
      @media screen and (max-width: 768px) {
        min-height: 110PX;
        text-indent: 2em;
        font-size: 12px;
      }
      i{
        padding-right: 5px;
        color: #19B21E;
        font-weight: bold
      }
    }
    .item_navigate {
      width: 100PX;
      height: 30PX;
      padding: 0 10px;
      background: #ffa400;
      color: #fff;
      border-radius: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      margin-top: 40px;
      cursor: pointer;
      z-index: 2;
      position: inherit;
      @media screen and (max-width: 768px) {
        margin-bottom: 10PX;
        font-size: 14px;
      }
    }
  }
}
</style>